document.addEventListener('DOMContentLoaded', () => {
    "use strict";
    let socialContent = document.querySelector('.social-media-links---content');
    let socialContentPlaceholder = document.querySelector('#footer-social-placeholder');
    let subscribeContent = document.querySelector('.footer-block--newsletter');
    let subscribeContentPlaceholder = document.querySelector('#footer-subscribe-placeholder');
    let subscribeContentPlaceholderMobile = document.querySelector('#footer-subscribe-placeholder-mobile');
    let socialContentPlaceholderMobile = document.querySelector('#footer-social-placeholder-mobile');

     // Move Social Content
     waitForElm('.social-media-links---content').then((elm) => {
        copyContent(socialContent, socialContentPlaceholder);
    });

     // Move Subscribe Content
     waitForElm('.footer-block--newsletter').then((elm) => {
        copyContent(subscribeContent, subscribeContentPlaceholder);
    });


     function waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }

    function copyContent(contentToCopy, whereToCopyContent) {
        if(contentToCopy) {
            if (whereToCopyContent) {
                whereToCopyContent.append(contentToCopy);

            }  
        }
    }

    // Resize handler
    function changeElementLocation(elem1, placeholder1, placeholder2) {
        if (window.matchMedia("(min-width: 750px)").matches) {
                copyContent(elem1, placeholder1);
            } else {
                copyContent(elem1, placeholder2);
        }
    }

    window.addEventListener("resize", function() {
        changeElementLocation(subscribeContent, subscribeContentPlaceholder, subscribeContentPlaceholderMobile);
        changeElementLocation(socialContent, socialContentPlaceholder, socialContentPlaceholderMobile);
    });

    setTimeout(() => {
        changeElementLocation(subscribeContent, subscribeContentPlaceholder, subscribeContentPlaceholderMobile);
        changeElementLocation(socialContent, socialContentPlaceholder, socialContentPlaceholderMobile);
    }, 100);
    
  


    // Toggle links on mobile
    let footerToggler = document.querySelectorAll('.footer-block__heading');
    if ( footerToggler.length > 0 ) {
        footerToggler.forEach( item => {
            item.addEventListener('click', function(e) {
                if(item.classList.contains('active')) {
                    item.classList.remove('active')
                } else {
                    item.classList.add('active');
                }
            })
        })
    }

})